var COOKIES_AGREEMENT = {
    cookiesBtn: '.b__cookies button',
    cookiesDom: '.b__cookies',
    init: function () {

        if (COOKIES_AGREEMENT.alreadyAgreed()) {
            COOKIES_AGREEMENT.removeCookiesDom();
        } else {
            jQuery(COOKIES_AGREEMENT.cookiesDom).css('display', 'flex')
            jQuery(document).on('click', COOKIES_AGREEMENT.cookiesBtn, function () {
                localStorage.setItem('COOKIES_AGREED', 'true');
                COOKIES_AGREEMENT.removeCookiesDom();
            })
        }
    },
    alreadyAgreed: function () {

        var agreed = true;
        var cookiesAgreementStatus = localStorage.getItem('COOKIES_AGREED')

        if (cookiesAgreementStatus === 'true' ||
            cookiesAgreementStatus === true) {

            agreed = true;
        } else {
            agreed = false;
        }

        return agreed;
    },

    removeCookiesDom: function () {
        jQuery(COOKIES_AGREEMENT.cookiesDom).remove();
    },

    build: function () {
        COOKIES_AGREEMENT.init();
    }
}

COOKIES_AGREEMENT.build();